import "core-js/modules/es.array.find";
import "core-js/modules/es.function.name";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Watch, PropSync, Prop } from 'vue-property-decorator';
import TreeSelect from '@/components/TreeSelect.vue';
import { validateor } from '@/utils/validate';
import { createUuid } from '@/utils';
var defaultClient = {
  litigationStatusOneId: '',
  litigationStatusOneName: '',
  partyName: '',
  phoneNo: '',
  age: '',
  education: '',
  partyType: 'person',
  idCardNo: '',
  certificateType: '',
  sex: '',
  address: '',
  nation: '',
  corpName: '',
  corpAddress: '',
  corpPhone: ''
};

var ClientInfoFormDialog = /*#__PURE__*/function (_Vue) {
  _inherits(ClientInfoFormDialog, _Vue);

  var _super = _createSuper(ClientInfoFormDialog);

  function ClientInfoFormDialog() {
    var _this;

    _classCallCheck(this, ClientInfoFormDialog);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic;
    _this.caseNumType = 'default';
    _this.clientInfoFormRules = {
      litigationStatusOneId: validateor({
        required: true,
        trigger: 'change'
      }),
      partyType: validateor({
        required: true
      }),
      partyName: validateor({
        required: true,
        type: 'name',
        maxLength: 32
      }),
      certificateType: validateor({
        required: true,
        trigger: 'change'
      }),
      idCardNo: validateor({
        required: true,
        type: 'card'
      }),
      sex: [],
      age: validateor({
        type: 'int',
        minValue: 1,
        maxValue: 200
      }),
      address: validateor({
        maxLength: 32
      }),
      phoneNo: validateor({
        required: true,
        type: 'mobile'
      }),
      education: [],
      corpName: validateor({
        required: true,
        type: 'name',
        maxLength: 32
      }),
      corpAddress: validateor({
        type: 'common',
        maxLength: 32
      }),
      corpPhone: validateor({
        type: 'telOrMobile',
        maxLength: 32
      })
    };
    _this.clientInfoForm = defaultClient;
    _this.dialogArea = [900, 550];
    _this.canSubmit = true;
    return _this;
  }

  _createClass(ClientInfoFormDialog, [{
    key: "handlePartyTypeChange",
    value: function handlePartyTypeChange(e) {
      // TODO resize 高度过小时 label 放在同一行
      // this.dialogArea = (e === 'person' ? [900, 400] : [900, 550])
      this.dialogArea = e === 'person' ? [900, 550] : [900, 760];
    } // 显示时设置 clientInfoForm 数据

  }, {
    key: "handleExistDataChange",
    value: function handleExistDataChange() {
      var _this2 = this;

      if (this.dialogFormVisible === true) {
        this.canSubmit = true; // 保证使用 defaultClient 初始化 form，使 resetFields 方法符合预期
        // 否则先点击编辑后点击创建时，resetFields 会恢复为编辑时的数据
        // TODO 优化，会产生多余校验
        // 因为 form 有 resetFields 方法，所以直接修改 defaultClient
        // 存在bug: 点击创建后编辑数据，点击取消，再点击编辑后点击确定或取消，再点击创建。执行了 resetFields() 但是第一次编辑的数据未被清空
        // 所以还是拷贝一份 defaultClient

        this.clientInfoForm = Object.assign({}, defaultClient);

        if (this.existData) {
          this.$nextTick(function () {
            // 为避免修改原数据，拷贝一份 existData
            _this2.clientInfoForm = Object.assign({}, _this2.existData);
          });
        } else {
          // 新建时 resetFields() 取消校验报错
          if (this.$refs.clientInfoForm) {
            this.$refs.clientInfoForm.resetFields();
          }
        }
      } else {
        if (this.$refs.clientInfoForm) {
          this.$refs.clientInfoForm.resetFields();
        }
      }
    } // TODO 修改 idCardNo 校验规则

  }, {
    key: "handleCertificateTypeChange",
    value: function handleCertificateTypeChange() {// this.clientInfoFormRules.idCardNo = validateor({ required: true, type: 'identity' })
    } // 证件类型更新校验方式

  }, {
    key: "certificateTypeChange",
    value: function certificateTypeChange(val) {
      if (val === '111') {
        this.clientInfoFormRules.idCardNo = validateor({
          required: true,
          type: 'identity'
        });
      } else {
        this.clientInfoFormRules.idCardNo = validateor({
          required: true,
          type: 'card'
        });
      }
    }
  }, {
    key: "handleLitigationStatusOneIdChange",
    value: function handleLitigationStatusOneIdChange(id) {
      if (!id) return;
      var obj = this.litigationStatusIdOptions.find(function (item) {
        return item.id === id;
      });
      this.clientInfoForm.litigationStatusOneName = obj.name;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;

      this.canSubmit = false;
      var clientInfoFormRef = this.$refs.clientInfoForm;
      clientInfoFormRef.validate(function (valid, invalidFields) {
        if (valid) {
          _this3.dialogFormVisible = false; // 拷贝一份 clientInfoForm 传给 ClientInfo（不拷贝应该也没事）
          // 生成 uuid 字段

          var uuid = _this3.clientInfoForm.uuid ? '' : createUuid();

          _this3.$emit('submit', Object.assign({
            uuid: uuid
          }, _this3.clientInfoForm));
        } else {
          _this3.canSubmit = true;
        }

        clientInfoFormRef.focusFirstField();
      });
    } // TODO 根据姓名搜索当事人

  }, {
    key: "queryClients",
    value: function queryClients() {}
  }, {
    key: "handleSelectClient",
    value: function handleSelectClient() {}
  }, {
    key: "dialogTitle",
    get: function get() {
      if (this.existData) {
        return '编辑当事人';
      }

      return '新建当事人';
    }
  }]);

  return ClientInfoFormDialog;
}(Vue);

__decorate([PropSync('visible', {
  required: true
})], ClientInfoFormDialog.prototype, "dialogFormVisible", void 0);

__decorate([Prop({
  required: true
})], ClientInfoFormDialog.prototype, "existData", void 0);

__decorate([Prop({
  required: true,
  type: Array
})], ClientInfoFormDialog.prototype, "litigationStatusIdOptions", void 0);

__decorate([Watch('dialogFormVisible')], ClientInfoFormDialog.prototype, "handleExistDataChange", null);

__decorate([Watch('clientInfoForm.certificateType')], ClientInfoFormDialog.prototype, "handleCertificateTypeChange", null);

ClientInfoFormDialog = __decorate([Component({
  components: {
    TreeSelect: TreeSelect
  }
})], ClientInfoFormDialog);
export default ClientInfoFormDialog;